export enum ClearingDebtType {
    Yes = 1,
    No = 2
}